import { render, staticRenderFns } from "./PatientAlertsList.vue?vue&type=template&id=7d1a4e14&"
import script from "./PatientAlertsList.vue?vue&type=script&lang=js&"
export * from "./PatientAlertsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports